var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidebar-content" },
    [
      _c("div", { staticClass: "sidebar-logos" }, [
        _c("a", { attrs: { href: "https://mcsuk.org" } }, [
          _c("svg", { attrs: { "aria-hidden": "true", focusable: "false" } }, [
            _c("use", { attrs: { href: "#mcs-logo" } }),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
      ]),
      _vm._v(" "),
      _c("h1", [_vm._v("MPA Reality Check")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Insights into how fully we are protecting and managing our marine environment."
        ),
      ]),
      _vm._v(" "),
      _c("main-map-legend"),
      _vm._v(" "),
      _c("p", { staticClass: "link-styles" }, [_c("data-sources-popup")], 1),
      _vm._v(" "),
      _c("p", { staticClass: "sidebar-bottom-text" }, [
        _vm._v(
          "The Reality Check is iterative, and will be reviewed as management changes."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-credits" }, [
        _c("p", [_vm._v("Data version: " + _vm._s(_vm.versionCode))]),
        _vm._v(" "),
        _vm._m(2),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { attrs: { target: "_blank", href: "https://www.wildlifetrusts.org/" } },
      [
        _c("img", {
          attrs: {
            src: "/static/img/TWT_LOGO_PRIMARY_COLOUR.SVG.svg",
            alt: "The Wildlife Trusts",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        attrs: {
          target: "_blank",
          href: "https://www.bluemarinefoundation.com",
        },
      },
      [
        _c("img", {
          attrs: {
            src: "/static/img/BMF_Logo_CMYK_Blue.svg",
            alt: "Blue Marine Foundation",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "link-styles" }, [
      _vm._v("Site by "),
      _c(
        "a",
        { attrs: { href: "https://marinemapping.com", target: "_blank" } },
        [_vm._v("MarineMapping")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }